import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { isRemoveAllEntityActionType } from '../../../../Entity'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../FormikEntityActionConfigFields.constants'

export function useFormikEntityActionConfigFieldsClearFields({ emptyValues }) {
  const { setValues, values } = useFormikContext()

  const actionTypeValue =
    values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]

  const actionTypeValueIsRemoveAll =
    isRemoveAllEntityActionType(actionTypeValue)

  useEffect(() => {
    if (actionTypeValueIsRemoveAll) {
      setValues({
        ...emptyValues,
        [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: actionTypeValue,
      })
    }
  }, [actionTypeValue])

  return { actionTypeValueIsRemoveAll }
}
